export default __webpack_public_path__ + "static/media/cource-complete.75110cc2.png";